[
  {
    "id": 1,
    "name": "MATERIAL",
    "type": 0
  },
  {
    "id": 2,
    "name": "ANIMATION",
    "type": 0
  },
  {
    "id": 5,
    "name": "MERCH",
    "type": 0
  },
  {
    "id": 7,
    "name": "RENT",
    "type": 0
  },
  {
    "id": 1,
    "name": "MATERIAL (KIT)",
    "type": 1
  }
]